import React, { useEffect } from "react";
import HygineFormStructure from "../../components/hygiene-system/hygiene-form/HygineFormStructure";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../components/common-data/Converts";

const HygineOpenForm = () => {
  const storedData = JSON.parse(
    localStorage.getItem("hygiene_form_mobile_number")
  );
  const userInfoData = storedData?.userInfoData || "";

  useEffect(() => {
    if (storedData?.date !== FORMATTED_TODAY_DATE_YYYYMMDD) {
      localStorage.removeItem("hygiene_form_mobile_number");
    }
  }, []);

  console.log(
    "storedData=> ",
    storedData,
    storedData?.date === FORMATTED_TODAY_DATE_YYYYMMDD
  );

  return (
    <HygineFormStructure
      userInfoData={userInfoData}
      mobileNumber={storedData?.mobileNumber}
    />
  );
};

export default HygineOpenForm;
